module.exports = __webpack_public_path__ + "static/media/tutoriales_kalenday.094fbe17.svg";